import React from "react";
import styled from "styled-components";

import { getStaticUrl } from "js/config";

const CloudIcon = styled.i`
    color: #11a9e2;
`;

const SidePaneImage = styled.img`
width: 24px;
`;

export enum FILE_TYPES {
    IMAGE = "IMAGE",
    VIDEO = "VIDEO"
}

export enum MEDIA_DIVIDER_TYPES {
    DIVIDER = "divider",
    CONST_DIVIDER = "const_divider"
}

export enum MEDIA_TYPES {
    UPLOAD = "upload",
    DROPBOX = "dropbox",
    BYNDER = "bynder",
    BOX = "box",
    GOOGLE_DRIVE = "google_drive",
    ONE_DRIVE = "one_drive",
    VIMEO = "vimeo",
    YOUTUBE = "youtube",
    UPGRADE = "upgrade"
}

export const AVAILBLE_VIDEO_SOURCES = [
    MEDIA_TYPES.UPLOAD,
    MEDIA_DIVIDER_TYPES.CONST_DIVIDER,
    MEDIA_TYPES.VIMEO,
    MEDIA_TYPES.YOUTUBE,
    MEDIA_DIVIDER_TYPES.DIVIDER,
    MEDIA_TYPES.DROPBOX,
    MEDIA_TYPES.BYNDER,
    MEDIA_TYPES.BOX,
    MEDIA_TYPES.GOOGLE_DRIVE,
    MEDIA_TYPES.ONE_DRIVE
];

export const AVAILBLE_IMAGE_SOURCES = [
    MEDIA_TYPES.UPLOAD,
    MEDIA_DIVIDER_TYPES.CONST_DIVIDER,
    MEDIA_TYPES.DROPBOX,
    MEDIA_TYPES.BYNDER,
    MEDIA_TYPES.BOX,
    MEDIA_TYPES.GOOGLE_DRIVE,
    MEDIA_TYPES.ONE_DRIVE
];

export interface SizePaneProps {
    type?: string
    id: MEDIA_TYPES | MEDIA_DIVIDER_TYPES
    icon?: JSX.Element
    title?: string
    allowed?: boolean
}

export const mediaLibraryPaneOptions: Array<SizePaneProps> = [{
    icon: <CloudIcon className="logo micon">cloud_upload</CloudIcon>,
    id: MEDIA_TYPES.UPLOAD,
    title: "Upload a file"
},
{
    icon: <SidePaneImage src={getStaticUrl("/images/file_hosting/vimeo-icon.svg")} />,
    id: MEDIA_TYPES.VIMEO,
    title: "Vimeo"
},
{
    icon: <SidePaneImage src={getStaticUrl("/images/file_hosting/youtube-icon.svg")} />,
    id: MEDIA_TYPES.YOUTUBE,
    title: "YouTube"
},
{
    id: MEDIA_DIVIDER_TYPES.DIVIDER,
    type: "divider"
},
{
    id: MEDIA_DIVIDER_TYPES.CONST_DIVIDER,
    type: "divider"
},
{
    icon: <SidePaneImage src={getStaticUrl("/images/file_hosting/dropbox.svg")} />,
    id: MEDIA_TYPES.DROPBOX,
    title: "Dropbox"
},
{
    icon: <SidePaneImage src={getStaticUrl("/images/file_hosting/bynder-icon.svg")} />,
    id: MEDIA_TYPES.BYNDER,
    title: "Bynder"
},
{

    icon: <SidePaneImage src={getStaticUrl("/images/file_hosting/google-drive-icon.svg")} />,
    id: MEDIA_TYPES.GOOGLE_DRIVE,
    title: "Google Drive"
},
{

    icon: <SidePaneImage src={getStaticUrl("/images/file_hosting/box.svg")} />,
    id: MEDIA_TYPES.BOX,
    title: "Box"
},
{
    id: MEDIA_TYPES.UPGRADE,
    title: "More Options..."
},
{
    icon: <SidePaneImage src={getStaticUrl("/images/file_hosting/onedrive.svg")} />,
    id: MEDIA_TYPES.ONE_DRIVE,
    title: "OneDrive"
}];
